module.exports = __webpack_public_path__ + "img/ud_05.508ecc2b.png";